import { createGlobalStyle } from 'styled-components';

import { BORDER_RADIUS, BREAKPOINTS, FONT_SIZE, FONT_WEIGHT, media } from './constants';
import { resetCss } from './resetCss';
import { getThemeVariables } from './themeVariables';

export default createGlobalStyle`

    ${resetCss}
    :root {
        ${getThemeVariables}
    }

    html,
    body,
    #root {
        height: 100%;
        min-height: 100%;
        padding: 0;
        margin: 0;
        font-family: "Inter", serif;
    }

    .h-max {
        height: max-content !important;
    }

    .h-full {
        height: 100%;
    }

    .d-none {
        display: none;
    }

    .w-max {
        width: max-content !important;
    }

    .w-full {
        width: 100%;

        &--i {
            width: 100% !important;
        }
    }

    .w-50 {
        width: 50%;
    }

    .relative {
        position: relative;
    }

    .p-0 {
        padding: 0;

        &--i {
            padding: 0 !important;
        }
    }
      
        .pl-0 {
        padding-left: 0;

        &--i {
            padding-left: 0 !important;
        }
    }
    

    .m-0 {
        margin: 0;

        &--i {
            margin: 0 !important;
        }
    }

    .mw-unset {
        max-width: unset;
    }

    .search-overlay {
        box-shadow: var(--box-shadow);
        top: 60px !important;

        @media only screen and ${media.xs} and (max-width: ${BREAKPOINTS.md - 0.02}px) {
            width: calc(100vw - 16px);
            max-width: 600px;
        }

        @media only screen and ${media.md} {
            width: 323px;
        }
    }

    .anticon-green svg {
        color: var(--green);
    }

    // notifications start
    .ant-notification-notice {
        width: 36rem;
        padding: 2rem;
        min-height: 6rem;

        .ant-notification-notice-with-icon .ant-notification-notice-message {
            margin-bottom: 0;
            margin-left: 2.8125rem;

            .title {
                height: max-content;
            }
        }

        .ant-notification-notice-with-icon .ant-notification-notice-description {
            margin-left: 4.375rem;
            margin-top: 0;
        }

        .ant-notification-notice-icon {
            font-size: 2.8125rem;
            margin-left: 0
        }

        .ant-notification-notice-close {
            top: 1.25rem;
            right: 1.25rem;
        }

        .ant-notification-notice-close-x {
            display: flex;
            font-size: 0.9375rem;
        }

        .notification-without-description {
            .ant-notification-notice-close {
                top: 1.875rem;
            }

            .ant-notification-notice-with-icon .ant-notification-notice-description {
                margin-top: 0.625rem;
            }
        }

        .title {
            font-size: ${FONT_SIZE.xxl};
            height: 3rem;
            margin-left: 1.5rem;
            display: flex;
            align-items: center;
            font-weight: ${FONT_WEIGHT.bold};

            &.title-only {
                color: var(--gray);
                font-size: ${FONT_SIZE.md};
                margin-left: 0.75rem;
                font-weight: ${FONT_WEIGHT.semibold};
            }
        }

        .description {
            color: #404040;
            font-size: ${FONT_SIZE.md};
            font-weight: ${FONT_WEIGHT.semibold};
            line-height: 1.375rem;
        }

        &.ant-notification-notice-success {
            background: var(--greenUltraLight);

            .title {
                color: var(--green);
            }
        }

        &.ant-notification-notice-info {
            background: var(--blueLight);

            .title {
                color: var(--green);
            }
        }

        &.ant-notification-notice-warning {
            background: var(--orangeLight);

            .title {
                color: var(--orange);
            }
        }

        &.ant-notification-notice-error {
            border: 1px solid var(--error-color);
            background: var(--redLight);

            .title {
                color: var(--error-color);
            }
        }

        .success-icon {
            color: var(--green);
        }

        .info-icon {
            color: var(--green);
        }

        .warning-icon {
            color: var(--orange);
        }

        .error-icon {
            color: var(--error-color);
        }
    }

    .ant-menu-inline, .ant-menu-vertical {
        border-right: 0;
    }

    // notifications end

    .block {
        display: block;

        &--i {
            display: block !important;
        }
    }

    .mb-20 {
        margin-bottom: 20px;
    }

    .mt-20 {
        margin-top: 20px;
    }

    .mt-16 {
        margin-top: 16px;
    }

    .mt-10 {
        margin-top: 10px;
    }

    .mr-20 {
        margin-right: 20px;
    }

    .mb-10 {
        margin-bottom: 10px;
    }

    .mr-10 {
        margin-right: 10px;
    }

    .ml-10 {
        margin-left: 10px;
    }

    .ml-auto {
        margin-left: auto;
    }

    .mt-auto {
        margin-top: auto;
    }

    .margin-20 {
        margin: 20px;
    }

    .m-x-auto {
        margin-left: auto;
        margin-right: auto;
    }

    .pr-20 {
        padding-right: 20px;
    }

    .pl-20 {
        padding-left: 20px;
    }

    .bullet {
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background-color: var(--grey);

        &.red {
            background-color: var(--red);
        }

        &.green {
            background-color: var(--green);
        }
    }

    .delete-user-modal .icon {
        font-size: 16px;
    }

    .delete-user-modal .link {
        padding: 10px 0;
        font-size: 16px;
    }

    .font-size18 {
        font-size: 18px;
    }

    .text-white {
        color: var(--white) !important;
    }

    .text-black {
        color: var(--black) !important;
    }

    .text-gray {
        color: var(--gray);
			
			& > span {
				color: var(--gray) !important;
			} 
		}

    .text-red {
        color: var(--red) !important;
    }

    .text-grayLight {
        color: var(--grayLight) !important;
    }

    .text-green {
        color: var(--green) !important;
			
			& > span {
				color: var(--green) !important;
			} 
    }

    .text-blue {
        color: var(--blue) !important;
    }

    .text-underline {
        text-decoration: underline;
    }

    .text-center {
        text-align: center;
    }

    .block-title {
        font-size: ${FONT_SIZE.md};
        line-height: 32px;
    }

    .hover-opacity {
        transition: opacity .3s;

        &:hover {
            opacity: .9;
        }
    }

    // TODO: Think on encapsulation of ant overrides.
    /**
        ANTD Form elements overrides.
     */
    .ant-form-item {
        margin-bottom: 0;

        .ant-form-item-label {
            padding-bottom: 0;

            label {
                font-size: ${FONT_SIZE.xs};
                font-weight: ${FONT_WEIGHT.regular};
                color: var(--gray);
                height: unset !important;
            }
        }

        .ant-input-lg,
        .ant-input-affix-wrapper-lg {
            padding: 5px 11px;
        }

        .ant-input-affix-wrapper:focus,
        .ant-input:focus {
            box-shadow: none;
        }

        .ant-form-item-explain-error {
            font-weight: ${FONT_WEIGHT.regular};
        }

        .ant-form-item-control-input {
            min-height: unset !important;
        }

        .ant-upload-wrapper span.ant-upload {
            display: flex;
            flex-direction: row-reverse;
            gap: 8px;

            article.ant-typography {
                font-size: ${FONT_SIZE.xxs};
                font-weight: ${FONT_WEIGHT.regular};
                color: var(--gray);
            }
        }
    }

    .form-item__wrapper {
        gap: 8px;

        label {
            font-size: 14px;
						line-height: 1;
            font-weight: ${FONT_WEIGHT.regular};
            height: unset !important;
        }

        .description {
            color: var(--gray);
            font-weight: ${FONT_WEIGHT.light};
        }
    }

    .ant-checkbox-wrapper span {
        font-weight: ${FONT_WEIGHT.regular};
    }

    /**
        ANTD Input type search.
     */
    .ant-input-search {
        max-width: 300px;

        input {
            font-size: ${FONT_SIZE.xxs};
        }

        .ant-input-search-button.ant-btn.ant-btn-default:not(.ant-btn-dangerous) {
            border-color: var(--grayLight);
            background-color: var(--white);
        }

        .ant-btn.ant-btn-default {
            background-color: var(--white);
            border-color: var(--grayLight);
        }
    }

    .ant-select-focused.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
        box-shadow: none;
    }

    /**
        ANTD Button overrides.
     */
    .ant-btn {
        width: max-content;
        box-shadow: none;
        font-weight: ${FONT_WEIGHT.regular};
        padding: 0 16px;

        &.ant-btn-sm {
            font-size: ${FONT_SIZE.xxs};
            padding: 0 16px;
        }

        &.ant-btn-lg {
            font-size: ${FONT_SIZE.xs};
            height: 36px;
            padding: 0 16px;
        }

        &.ant-btn-default:not(.ant-btn-dangerous) {
            color: var(--green);
            border-color: var(--green);
            background-color: transparent;

            &[disabled] {
                opacity: 0.5;
            }
        }
    }

    .ant-dropdown-trigger:focus-visible {
        outline: none;
    }

    /**
				ANTD Typography overrides.
		 */
    span.ant-typography {
        font-weight: ${FONT_WEIGHT.regular};

        &.ant-typography-secondary {
            color: var(--gray);
        }
    }

    /**
        ANTD Table overrides.
     */
    .ant-table-wrapper {
        table {
            border-radius: ${BORDER_RADIUS};
        }

        .ant-table-thead,
        .ant-table-tbody {
            // General Cell styling.

            & > tr > th,
            & > tr > td {
                color: var(--gray);
                border-color: var(--grayUltraLight);
                font-weight: ${FONT_WEIGHT.regular};
                background-color: var(--white);
                padding: 5px 10px;
                height: px;

                &.highlighted {
                    background-color: var(--greenUltraLight);
                }

                span {
                    font-weight: ${FONT_WEIGHT.regular};
                    font-size: ${FONT_SIZE.xxs};
                    color: var(--gray);
                }

                a {
                    text-decoration: underline;
                    color: var(--blue);
                }
            }

            // Table row styling.

            & > tr > td {
                button {
                    height: 100%;
                }

                &.ant-table__actions {
                    border-left: 1px solid var(--grayUltraLight);
                    padding: 0;

                    button {
                        text-align: left;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        padding: 0 10px;

                    }

                    &:hover {
                        background-color: var(--grayUltraLight);
                    }
                }
            }

            // Table head styling.

            & > tr > th {
                padding: 5px 10px;
                color: var(--black);
                font-weight: ${FONT_WEIGHT.medium};

                span {
                    color: var(--black);
                    font-weight: ${FONT_WEIGHT.medium};
                }

                // TH Icons.

                .anticon-filter,
                .anticon-caret-up,
                .anticon-caret-down {
                    svg {
                        color: var(--grayLight);
                        transition: color 0.3s;
                    }

                    &.active svg {
                        color: var(--green);
                    }
                }

                .ant-table-filter-trigger.active svg,
                .ant-table-filter-trigger.ant-dropdown-open svg {
                    color: var(--green);
                }
            }

            .ant-table-row.ant-table-row-selected > .ant-table-cell {
                background-color: var(--greenUltraLight);
            }

            .ant-table-column-title {
                font-size: ${FONT_SIZE.xs};
            }

            .ant-table-row > .ant-table-cell-row-hover {
                background-color: var(--grayUltraLight);
            }

            svg {
                &[data-icon="close"] {
                    font-size: 10px;
                }
            }

            .ant-table-expanded-row .ant-table-cell {
                padding: 0 16px;

                .ant-row .ant-col {
                    font-weight: ${FONT_WEIGHT.light};
                    font-size: ${FONT_SIZE.xxs};

                    &:first-child {
                        font-weight: ${FONT_WEIGHT.medium};
                    }
                }
            }

            .ant-table-row-expand-icon-cell .ant-table-row-expand-icon {
                width: 20px;
                height: 20px;

                &:before,
                &:after {
                    inset-inline-start: 0;
                    inset-inline-end: 0;
                }

                &:before {
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 12px;
                }

                &:after {
                    top: 50%;
                    bottom: 0;
                    left: 50%;
                    transform: rotate(0deg) translate(-50%, -50%);
                    inset-inline-start: 50%;
                    height: 12px;
                    opacity: 0;
                }

                &-collapsed {
                    &:before {
                        transform: rotate(0deg) translate(-50%, -50%);
                    }

                    &:after {
                        transform: rotate(0deg) translate(-50%, -50%);
                        opacity: 1;
                    }
                }
            }
        }
    }

    /**
        ANTD Table pagination overrides.
     */
    .ant-table-pagination {
        .ant-pagination-total-text {
            font-size: ${FONT_SIZE.xxs};
            font-weight: ${FONT_WEIGHT.regular};
            margin-right: auto;
            color: var(--gray);
        }

        .ant-pagination-item {
            a {
                font-size: ${FONT_SIZE.xxs};
                color: var(--gray);
            }

            &-active {
                background-color: transparent;

                a {
                    color: var(--green);
                }
            }
        }
    }

    /**
        ANTD Notifications overrides.
     */
    .ant-notification {
        .ant-notification-notice {
            border: none;
            border-radius: ${BORDER_RADIUS};

            &-icon {
                top: 30px;
            }

            &-description {
                padding-left: 12px;
            }

            .title {
                font-weight: ${FONT_WEIGHT.regular};
                font-size: ${FONT_SIZE.lg};
            }

            .description {
                font-weight: ${FONT_WEIGHT.regular};
                font-size: ${FONT_SIZE.xs};
            }

            /**
                Mobile: a long message renders at desktop type inside a ~312px notice,
                which runs to five or six lines. Shrink the type and claw back the
                horizontal space the icon gutter and padding take up.
             */
            @media only screen and (max-width: ${BREAKPOINTS.md - 0.02}px) {
                padding: 1.25rem;

                .ant-notification-notice-icon {
                    top: 1.25rem;
                    font-size: 1.75rem;
                }

                .ant-notification-notice-with-icon .ant-notification-notice-message {
                    margin-left: 2.25rem;
                }

                .ant-notification-notice-with-icon .ant-notification-notice-description {
                    margin-left: 2.25rem;
                    padding-left: 0;
                }

                .title {
                    margin-left: 0.75rem;
                    font-size: ${FONT_SIZE.md};

                    &.title-only {
                        font-size: ${FONT_SIZE.xs};
                        margin-left: 0.5rem;
                    }
                }

                .description {
                    font-size: ${FONT_SIZE.xxs};
                }
            }
        }

    }

    /**
				Table filter styling.
		 */
    .ant-dropdown .ant-table-filter-dropdown {
        min-width: 200px;

        ul {
            padding: 0;
        }

        .ant-dropdown-menu-item-selected,
        .ant-dropdown-menu-item-selected:hover {
            background-color: var(--greenUltraLight);
        }

        .ant-dropdown-menu-title-content span {
            color: var(--gray);
            font-size: ${FONT_SIZE.xxs};
        }

        .ant-table-filter-dropdown-btns button {
            font-size: ${FONT_SIZE.xxs};

            &:first-child {
                color: var(--gray);
            }
        }
    }

    /**
     Select variations.
     */
    .ant-select.primary {
        .ant-select-selector {
            background-color: var(--green);

            .ant-select-selection-item,
            .ant-select-selection-placeholder {
                color: var(--white);
            }
        }

        .ant-select-arrow {
            color: var(--white);
        }
    }

    /**
    Upload wrapper.
     */
    .ant-upload-wrapper.w-full {
        display: block;

        .ant-upload-select {
            width: 100%;
        }
    }

    /**
        Crop text with dots at the end.
     */
    .text-crop-with-dots {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        white-space: nowrap;
    }
`;
